import { css } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";

export const useStyles = withBasicStyles(() => ({
  logoText: css`
    font-size: 30px;
    line-height: 36px;
    font-weight: 800;
    width: 100%;
    min-width: 330px;
    margin-top: 30px;
    color: transparent;
    background: linear-gradient(to right, #ff69b4, #4169e1);
    background-clip: text;
    width: 0;
    overflow: hidden;
    text-overflow: unset;
    white-space: nowrap;
    animation: typewiriter 1s forwards;
  `,

  sendWrapper: css`
    position: relative;
    width: 100%;
    align-self: center;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  `,

  uploadButton: css`
    border: 0;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border-radius: 50%;
    color: #6b7280;
    transition: background 0.2s;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  `,
}));
